<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Pengumuman Detail
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="wrapper">
            <div class="body">
                <div class="mb10 mt10">
                    <div class="data bg-round-white p10 mb10">
                        <div class="box-horizontal">
                            <div class="flex-1 f13">
                                <span class="block f15 primary-color bt-1" style="text-transform: capitalize;">{{get.data.params.judul}}</span>
                            </div>
                        </div>
                        <div class="box-horizontal">
                            <div class="flex-1 f13">
                                <span class="block f12 hitam" v-html="myGlobal.unpetik(get.data.text)"></span>
                            </div>
                        </div>
                        <div class="box-horizontal">
                            <div class="flex-1 f13">
                                <small class="block gray">Tanggal : </small>
                                <span class="block f12 primary-color">{{myGlobal.tglIndo(get.data.params.tanggal)}} || {{get.data.params.jam}}</span>
                            </div>
                        </div>
                        <div class="box-horizontal">
                            <div class="flex-1 f13">
                                <small class="block gray">Status : </small>
                                <strong v-if="get.data.params.status == 'info'" class="primary-color">INFO</strong>
                                <strong v-else class="red">URGENT</strong>
                            </div>
                        </div>
                        <div class="box-horizontal" v-if="get.data.params.status == 'selesai'">
                            <div class="flex-1 f13">
                                <small class="block gray">Kerusakan : </small>
                                <span>{{get.data.params.kerusakan}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                params: '',
                text: ''
            }),
            list() {
                var datax = {
                    token: 'TangTung ' //+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
            }
        }
        const met = {
            back() {
                window.history.back();
            },
            logout() {
                myGlobal.android("logout" , null);
            },
            wa() {
                myGlobal.android("waCS" , get.data.cs);
            },
            pengaduan() {
                router.push({ 
                    name: 'pengaduan'
                });
            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx,
            myGlobal
        }

    },
    mounted () {        
        this.redirectx.checkApp();
        
        //console.log(sessionStorage.getItem('AkunPageData'));
        this.get.data.params = this.$route.params.data;


        var d = this.get.data.params;
        this.get.data.text = this.$route.params.data.text.replace(/\n/g, "<br />");

        //console.log(this.get.data.text);
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Pengumuman/detail.vue